import React, { useState} from "react";
// node.js library that concatenates classes (strings)
// reactstrap components
import {
  Button,
  Card,
  CardTitle,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  CardImg
} from "reactstrap";
import Header from "components/Headers/Header.js";
import HeaderEmpty from "components/Headers/HeaderEmpty";
import MoneySellers from "./MoneySellers";
import DaySelfSales from "views/seller/DaySelfSales";
import TopSeller from "views/seller/TopSeller";
import EditOrders from "views/examples/ticketing/EditOrders";
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import {openDoorAPI} from 'network/ApiAxios'

const Index = (props) => {
    const [camera, setcamera] = useState(false)
    const [doorOpen, setDoorOpen] = useState('primary');
  
    const scanQR = ()=>{
      setcamera(!camera)
    }

    const openDoor = async()=>{
      const resAxios = await openDoorAPI()
      if(resAxios.data.success){
        setDoorOpen('action')
      }else{
        setDoorOpen('error')
      }
    }

    return (
      <>
      <HeaderEmpty />  
        {/* Page content */}
        <Container fluid>
         
          <Row  >
            <Col className="mb-5 mt-8 mb--7 mb-xl-0" xl="8">
              <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                  <Row className="align-items-center">
                    <div className="col">
                      <h2 className="text-white">Money with sellers</h2>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <MoneySellers/>
                </CardBody>
              </Card>
            </Col>
            <Col xl="4" className="mt-8">
              <Card className="shadow">
                <CardHeader className="bg-transparent">
                  <Row>
                    <div className="d-flex" style={{alignItems: "center"}}>
                      <h2 className="mb-0 mr-5">Today Top Seller</h2>
                      <CardImg
                      style={{borderRadius: "150px",}}
                      alt="Card image cap"
                      src={require('./shan.jpeg').default}
                      
                      width="108"
                      height='192'
                    />
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                   <TopSeller/>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="8">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Day Sales</h3>
                    </div>
                    <div className="col text-right">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        See all
                      </Button>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                   <DaySelfSales/>
                </CardBody>
              </Card>
            </Col>
            <Col xl="4">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Door Access
                        </CardTitle>
                        <Button onClick={openDoor} ><MeetingRoomIcon color={doorOpen} />Open Door</Button>
                      </div>
                  </Row>
                </CardHeader>
                
              </Card>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="12">
              <Card className="shadow">
                <CardBody>
                   <EditOrders/>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  
}

export default Index;
